import * as React from "react";
const SvgForward = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 8V4l8 8-8 8v-4H4V8h8z",
  fill: "currentColor"
}));
export default SvgForward;